export default "__VITE_ASSET__7uHPdysLKtuyAgSzAal7Ig__"